import * as React from 'react';
import type { SVGProps } from 'react';
const ArrowRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 256 256"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M224.49 136.49L152.49 208.49C150.236 210.744 147.178 212.011 143.99 212.011C140.802 212.011 137.744 210.744 135.49 208.49C133.236 206.236 131.969 203.178 131.969 199.99C131.969 196.802 133.236 193.744 135.49 191.49L187 140H40C36.8174 140 33.7652 138.736 31.5147 136.485C29.2643 134.235 28 131.183 28 128C28 124.817 29.2643 121.765 31.5147 119.515C33.7652 117.264 36.8174 116 40 116H187L135.51 64.48C133.256 62.2256 131.989 59.1681 131.989 55.98C131.989 52.7919 133.256 49.7343 135.51 47.48C137.764 45.2256 140.822 43.9592 144.01 43.9592C147.198 43.9592 150.256 45.2256 152.51 47.48L224.51 119.48C225.629 120.596 226.516 121.923 227.121 123.383C227.726 124.843 228.036 126.409 228.034 127.989C228.033 129.57 227.719 131.134 227.11 132.593C226.502 134.052 225.612 135.376 224.49 136.49Z"
      fill="currentColor"
    />
  </svg>
);
export default ArrowRight;
